import { Outlet, Route, Routes } from "react-router-dom";
import { useState } from "react";
import ListadoNodos from "./ListadoNodos";
import RegistrarNodoDialog from "./RegistrarNodoDialog";
import DetalleNodoDialog from "./DetalleNodoDialog";

export default function Nodos() {

    const [reloadNodos, setReloadNodos] = useState(0);

    return (
        <>
            <Outlet />
            <Routes>
                <Route path="/" element={<ListadoNodos
                    reload={reloadNodos} />} >
                    <Route path="nuevo" element={<RegistrarNodoDialog
                        onShouldUpdate={() => setReloadNodos(reloadNodos + 1)} />} />
                    <Route path=":nodoId" element={<DetalleNodoDialog
                        onShouldUpdate={() => setReloadNodos(reloadNodos + 1)} />} />
                </Route>
            </Routes>
        </>
    );
}
